<template>
  <div class="lib__form__main" data-cy="tva-component">
    <ValidationObserver ref="validator" slim>
      <div class="lib__form__main__content">
        <header class="lib__form__main__header">
          <h2 class="lib__h2">{{ $t('vatInfo.title') }}</h2>
        </header>

        <vat-info-selector :company.sync="companyVatInfoSelection" :freelance.sync="freelanceVatInfoSelection" :individual.sync="individualVatInfoSelection" :type="contactInfoState.contactType" required></vat-info-selector>
        <vat-info-box :company="companyVatInfoSelection" :freelance="freelanceVatInfoSelection" :individual="individualVatInfoSelection" :type="contactInfoState.contactType"></vat-info-box>
      </div>
    </ValidationObserver>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Inject, Watch } from 'vue-property-decorator'
import Step from '@/components/steps/Step'
import VatInfoSelector from '@/components/inputs/Vat/VatInfoSelector.vue'
import VatInfoBox from '@/components/inputs/Vat/VatInfoBox.vue'
import {
  IndividualVatInfoSelection,
  CompanyVatInfoSelection,
  FreelanceVatInfoSelection,
  ContactInfo,
  VatInfo
} from '@/models'
import { State, Mutation } from 'vuex-class'

@Component({
  name: 'vat-info-step',
  components: {
    VatInfoSelector,
    VatInfoBox
  }
})
export default class VatInfoStep extends Step {
  //#region [Data]
  @State('requestId', { namespace: 'synergridConnection' })
  public requestId!: string
  @State('contactInfo', { namespace: 'synergridConnection/contactInfo' })
  public contactInfoState!: ContactInfo | null
  @State('individualVatInfoSelection', { namespace: 'synergridConnection/vatInfo' })
  public individualVatInfoSelectionState!: IndividualVatInfoSelection | null
  @State('freelanceVatInfoSelection', { namespace: 'synergridConnection/vatInfo' })
  public freelanceVatInfoSelectionState!: FreelanceVatInfoSelection | null
  @State('companyVatInfoSelection', { namespace: 'synergridConnection/vatInfo' })
  public companyVatInfoSelectionState!: CompanyVatInfoSelection | null

  public individualVatInfoSelection: IndividualVatInfoSelection | null = null
  public freelanceVatInfoSelection: FreelanceVatInfoSelection | null = null
  public companyVatInfoSelection: CompanyVatInfoSelection | null = null
  //#endregion

  //#region [Mutation]
  @Mutation('STORE', { namespace: 'synergridConnection/vatInfo' })
  private store!: (index: VatInfo | null) => void
  //#endregion

  //#region [Method]
  public mounted() {
    this.setIsBack(false)
    this.individualVatInfoSelection = this.individualVatInfoSelectionState
    this.freelanceVatInfoSelection = this.freelanceVatInfoSelectionState
    this.companyVatInfoSelection = this.companyVatInfoSelectionState
  }

  public async save(next: boolean, isValid: boolean) {
    if (isValid) {
      this.$appInsights.trackEvent('WR_SC_StepVat_Validated', {
        Segment: 'WR_SC',
        WebRef: this.requestId
      })
    }
    this.store({
      individualVatInfoSelection: this.individualVatInfoSelection,
      freelanceVatInfoSelection: this.freelanceVatInfoSelection,
      companyVatInfoSelection: this.companyVatInfoSelection
    })
  }
  //#endregion
}
</script>